// extracted by mini-css-extract-plugin
export default {"payments":"paymentsHistory_payments__ABnP1"};